export default "__VITE_ASSET__Zkna0OyF__"